import React, { useCallback } from 'react';
import IconButton from '@mui/material/IconButton';
import Star from '@mui/icons-material/Star';
import StarBorder from '@mui/icons-material/StarBorder';
import { useNotificationEntityFavorites } from '../NotificationEntityFavoritesContext';
import { useTranslation } from 'react-i18next';
import { translations } from 'app/locales/i18n';

interface IProjectFavoriteButtonProps {
  internalId: string;
}

export const ProjectFavoriteButton = ({
  internalId,
}: IProjectFavoriteButtonProps) => {
  const { t } = useTranslation();
  const { enabled, isFavorite, toggleFavorite, isSavingFavorite } =
    useNotificationEntityFavorites();

  const onClick = useCallback(
    async (event: React.MouseEvent) => {
      event.stopPropagation();
      event.preventDefault();
      await toggleFavorite(internalId);
    },
    [internalId, toggleFavorite],
  );

  if (!enabled) {
    return null;
  }

  const starred = isFavorite(internalId);

  return (
    <IconButton
      size="small"
      aria-label={
        starred
          ? t(translations.notificationEntityPage.removeFromFavorites)
          : t(translations.notificationEntityPage.addToFavorites)
      }
      onClick={onClick}
      disabled={isSavingFavorite}
    >
      {starred ? (
        <Star htmlColor="#FFB300" fontSize="small" />
      ) : (
        <StarBorder fontSize="small" />
      )}
    </IconButton>
  );
};
